import React, { useEffect, useState } from "react";
import Button from "../../../../components/form/Button";
import DestinationTestModal from "../modals/DestinationTestModal";

interface Props {
  showTestModal: boolean;
  isLoading: boolean;
  isTestLoading: boolean;
  testErrorMessage: string | null;
  onSave: () => void;
  onTest: () => Promise<void>;
  onTestCancel: () => void;
}

const DestinationSaveButton = ({
  showTestModal,
  isLoading,
  isTestLoading,
  testErrorMessage,
  onSave,
  onTest,
  onTestCancel,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setIsModalOpen(showTestModal);
  }, [showTestModal]);

  return (
    <>
      <Button
        variant="primary"
        className="min-w-[4rem]"
        onClick={onSave}
        loading={isLoading}
      >
        Save
      </Button>

      {isModalOpen && (
        <DestinationTestModal
          errorMessage={testErrorMessage}
          loading={isTestLoading}
          onClick={onTest}
          onRequestClose={() => {
            setIsModalOpen(false);
            onTestCancel();
            // setTestErrorMessageState(null);
          }}
        />
      )}
    </>
  );
};

export default DestinationSaveButton;
